import React from 'react';
import { Spin } from 'antd';


const LoadingBar: React.FC = () => {

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'calc(100vh - 268px)'
    }}>
      <Spin size="large" />
    </div>
)
  ;
};

export default LoadingBar;
